import mirrorCreator from 'mirror-creator';
import generateCrudConstants from './baseCrudConstants';

export default {
  ...mirrorCreator([
    'PACKAGE_TYPE_CHANGED',
    'PACKAGE_CURRENCY_CHANGED',
    'PACKAGE_EVENT_QUANTITY_CHANGED',
    'SETUP_CHECKOUT',
    'SET_SNAP_SELL_PACKAGE_ID',
    'IS_UPGRADING_CHANGED',
    'PRINT_ELIGIBILITY_TOGGLED'
  ]),
  ...generateCrudConstants('PRICE', 'R'),
  ...generateCrudConstants('SINGLE_PRICE', 'R'),
  ...generateCrudConstants('SUBSCRIPTION_PRICE', 'R'),
  ...generateCrudConstants('STRIPE_CARD', 'C'),
  ...generateCrudConstants('ORDER', 'C'),
  ...generateCrudConstants('EVENT_IMAGE', 'R'),
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/checkoutDataConstants.js